import axios from 'axios'
import Vue from 'vue'
import store from '@/store/store'
import routerMixin from '@/mixins/route'
import { loading } from '@/prototypes/u/loading'
import { getReadingTime } from '@/prototypes/u/other'
import router from '@/router/meta'

const protocol = window.location.protocol
let domain = window.location.hostname
domain = window.location.hostname.split('.').reverse()
if (domain.length > 2) domain = domain.splice(0, 2)
domain = domain.reverse().join('.')
domain = `${protocol}//core.${domain}/api`

const configApi = window.appConfig ? window.appConfig.API_URL : ''

const baseURL = configApi || process.env.VUE_APP_BASE_URL || domain

const API = axios.create({
  baseURL
  // You can add your headers here
})

const cancelToken = axios.CancelToken

const $t = sign => Vue.prototype.i18n.t(sign)

// 423 (locked) error keys returned by the server and their messages
const lockedErrorMessages = {
  opening_inventory_is_unlocked: 'others.alert.error.openingBalanceUnlock',
  opening_inventory_is_locked: 'others.alert.error.openingBalanceLocked',
  user_limit_reached: 'others.alert.error.userLimitReached',
  document_limit_reached: 'others.alert.error.documentLimitReached',
  active_session_locked: 'others.alert.error.activeSessionLocked'
}

API.interceptors.request.use(function (config) {
  // Do something before request is sent

  // throw new API.Cancel('you send sevaral request')
  // console.log(new cancelToken((cancel) => cancel('cancel repeat')).reason.message)

  config.headers['Cache-Control'] = 'no-store'

  const exceptUrls = ['v1/app/{tenant}/profile/browser-settings']

  if (config.method !== 'get' && exceptUrls.indexOf(config.url.split('?')[0]) === -1 && config.url.indexOf('loading=false') === -1) {
    loading.show()
  }

  const configApi = window.appConfig ? window.appConfig.API_URL : ''

  config.baseURL = configApi || process.env.VUE_APP_BASE_URL || domain

  if (config.loading) {
    store.dispatch('helper/changeRequestStatus', config.url)
    loading.show()
  }

  let tenant = ''
  if (router.currentRoute.params.hasOwnProperty('tenant')) {
    tenant = router.currentRoute.params.tenant || ''
  } else if (router.history.pending && router.history.pending.params && router.history.pending.params.tenant) {
    tenant = router.history.pending.params.tenant || ''
  } else if (config.paramData && config.paramData.tenant) {
    tenant = config.paramData.tenant
  }
  config.url = config.url.replace('{tenant}', tenant)

  return config

}, function (error) {
  // Do something with request error
  // console.log('rejected')
  return Promise.reject(error)
})

API.interceptors.response.use(function (response) {
  if (response.config.method !== 'get') {
    if (response.config.url.indexOf('loading=false') === -1) {
      loading.hide()
    }

    if (!response.config.url.includes('browser-settings') && ([200, 201].includes(response.status))) {
      store.dispatch('removePageChanges')
    }
  }

  if (store.state.helper.requestStatus.includes(response.config.url)) {
    store.dispatch('helper/changeRequestStatus', response.config.url)
  }

  if (store.state.helper.requestStatus.length === 0 || response.config.loading) {
    loading.hide()
  }

  if (response.config.method === 'patch') {
    routerMixin.methods.setPageHaveChange()
  }

  if (response.headers.date) {
    const date = response.headers.date.split(',')
    store.dispatch('helper/changeCurrentTime', date[1])
  }
  return response
}, function (error) {
  const loggedIn = localStorage.getItem('accessToken')

  if (error.response && error.response.status === 404 && error.config.type404 && router.meta.redirectNotFound) {
    router.replace({name: 'page-error-404', query: { type: error.config.type404 }})
  }

  if (error.config && error.config.url.indexOf('loading=false') === -1) {
    loading.hide(true)
  }

  if (loggedIn && error.response && error.response.status === 401) {
    store.dispatch('auth/noAccessUser')
  }
  // console.log(store.state.helper.requestStatus)
  if (loggedIn && error.response && error.response.status === 403) {
    Vue.prototype.$vs.notify({
      title: Vue.prototype.noAccessNotify.title,
      text: Vue.prototype.noAccessNotify.text,
      icon: 'icon-alert-circle',
      iconPack: 'feather',
      time: getReadingTime(Vue.prototype.noAccessNotify.text),
      color: 'danger'
    })
    // store.dispatch('auth/noAccessUser')
  }

  if (error.response && error.response.status === 423) {
    const key = error.response.data.message.split(':')[0]
    const text = $t(lockedErrorMessages[key] || 'others.alert.error.contactSupport')
    Vue.prototype.$vs.notify({
      title: $t('others.alert.error.title'),
      text,
      icon: 'icon-alert-circle',
      iconPack: 'feather',
      time: getReadingTime(text),
      color: 'danger'
    })
    loading.hide(true)
    store.dispatch('removePageChanges')
    // the error is already shown here, so the request never settles and callers don't show a second error
    return new Promise(() => {})
  }
  return Promise.reject(error)
})


export default API
